import './chart.css';

export const CHART_COLORS = [
    '#9CA9F8', '#005499', '#FF9076', '#66BAFF',
    '#33D1C1', '#008CFF', '#F0578A', '#FFDA5E',
    '#80B862', '#ae3a60ff'
];